// This file was autogenerated from /frontend/sail-next/packages/docs/src/examples/Accordion/PanelExample.tsx with go/sail-next-tailor-docs-publisher

import * as React from 'react';
import {view} from '@sail/ui';

export const PanelExample = () => {
  return (
    <view.div
      css={{
        padding: 'xlarge',
      }}
    >
      Accordion contents go here
    </view.div>
  );
};
